export class PlantIdRequest{
    unitcodeId : number;

      constructor(unitcodeId : number){
        this.unitcodeId = unitcodeId;
    }

}